import React, { FC } from 'react';
import { HStack } from '@bpba/ui-components';
import styled from 'styled-components';
import { compose } from 'styled-system';
import { backgroundImageTheme } from '../BackgroundImageTheme';

type Props = {
  title?: React.ReactNode;
} & React.ComponentProps<typeof HStack>;

export const ModalHeader: FC<Props> = ({ title, ...rest }) => {
  return (
    <StyledHStack
      padding={'20px'}
      paddingRight={[50, 80]}
      backgroundImage={'tertiary.gradient'}
      borderRadius="8px 8px 0px 0px"
      display="flex"
      justifyContent="space-between"
      {...rest}
    >
      {title}
    </StyledHStack>
  );
};

const StyledHStack = styled(HStack)(compose(backgroundImageTheme));
